<!-- src/components/Alert.vue -->
<template>
    <div v-if="message" :class="['alert', variant]">
      {{ message }}
    </div>
  </template>
  
  <script>
  export default {
    name: 'AlertBox',
    props: {
      message: { type: String, default: '' },
      variant: { type: String, default: 'error' }
    }
  };
  </script>
  
  <style scoped>
  .alert {
    padding: var(--space-sm, 10px);
    margin-top: var(--space-sm, -10px);
    border-radius: 4px;
  }
  .alert.error {
    color: var(--color-error-text, #a94442);
    background: var(--color-error-bg, #fdecea);
  }
  .alert.success {
    color: var(--color-success-text, #155724);
    background: var(--color-success-bg, #d4edda);
  }
  </style>
  